// extracted by css-extract-rspack-plugin
export default {"handle_btn":"handle_btn___Qg8tw"};